var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _circle3, _path13, _path14, _path15, _path16, _path17, _circle4, _path18, _path19, _path20, _path21, _path22, _circle5, _path23, _path24, _path25, _path26, _path27, _circle6, _path28, _path29, _path30, _path31, _path32, _circle7, _path33, _path34, _path35, _path36, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _rect, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveFinanceTracking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 147,
    viewBox: "0 0 273 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191 94C208.673 94 223 79.6731 223 62C223 44.3269 208.673 30 191 30C173.327 30 159 44.3269 159 62C159 79.6731 173.327 94 191 94Z",
    fill: "#55CF7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.537 59.5391L208.229 79.2314",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 188.537,
    cy: 59.5378,
    r: 14.7692,
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.613 55.8453V55.8453C191.613 54.4859 190.511 53.3838 189.151 53.3838H187.921C186.561 53.3838 185.459 54.4859 185.459 55.8453V56.2978C185.459 57.1624 185.913 57.9637 186.654 58.4085L190.418 60.6667C191.159 61.1116 191.613 61.9128 191.613 62.7775V63.2299C191.613 64.5894 190.511 65.6915 189.151 65.6915H187.921C186.561 65.6915 185.459 64.5894 185.459 63.2299V63.2299",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.535 53.3851L188.535 52.1543",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.535 66.9251L188.535 65.6943",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75 88C88.2548 88 99 77.2548 99 64C99 50.7452 88.2548 40 75 40C61.7452 40 51 50.7452 51 64C51 77.2548 61.7452 88 75 88Z",
    fill: "#55CF7E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1523 62.1543L87.9216 76.9235",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.1521,
    cy: 62.1521,
    r: 11.0769,
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4601 59.3803V59.3803C75.4601 58.3607 74.6336 57.5342 73.614 57.5342H72.6909C71.6713 57.5342 70.8447 58.3607 70.8447 59.3803V59.7197C70.8447 60.3682 71.185 60.9691 71.741 61.3027L74.5638 62.9964C75.1199 63.33 75.4601 63.931 75.4601 64.5795V64.9188C75.4601 65.9384 74.6336 66.7649 73.614 66.7649H72.6909C71.6713 66.7649 70.8447 65.9384 70.8447 64.9188V64.9188",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1514 57.5364L73.1514 56.6133",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1514 67.6916L73.1514 66.7686",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165 40C176.046 40 185 31.0457 185 20C185 8.9543 176.046 0 165 0C153.954 0 145 8.9543 145 20C145 31.0457 153.954 40 165 40Z",
    fill: "#55CF7E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.461 18.4629L175.769 30.7706",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.46,
    cy: 18.4603,
    r: 9.23077,
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 2.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.383 16.1508V16.1508C165.383 15.3011 164.694 14.6123 163.845 14.6123H163.076C162.226 14.6123 161.537 15.3011 161.537 16.1508V16.4335C161.537 16.974 161.821 17.4747 162.284 17.7528L164.636 19.1641C165.1 19.4422 165.383 19.943 165.383 20.4834V20.7661C165.383 21.6158 164.694 22.3046 163.845 22.3046H163.076C162.226 22.3046 161.537 21.6158 161.537 20.7662V20.7662",
    stroke: "#24284E",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.459 14.6149L163.459 13.8457",
    stroke: "#24284E",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.459 23.0768L163.459 22.3076",
    stroke: "#24284E",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42C87.8366 42 95 34.8366 95 26C95 17.1634 87.8366 10 79 10C70.1634 10 63 17.1634 63 26C63 34.8366 70.1634 42 79 42Z",
    fill: "#55CF7E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7686 24.7715L87.6147 34.6176",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.7684,
    cy: 24.7684,
    r: 7.38462,
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3064 22.9202V22.9202C79.3064 22.2405 78.7554 21.6895 78.0756 21.6895H77.4603C76.7805 21.6895 76.2295 22.2405 76.2295 22.9202V23.1464C76.2295 23.5788 76.4563 23.9794 76.827 24.2018L78.7089 25.3309C79.0796 25.5534 79.3064 25.954 79.3064 26.3863V26.6125C79.3064 27.2923 78.7554 27.8433 78.0756 27.8433H77.4603C76.7805 27.8433 76.2295 27.2923 76.2295 26.6125V26.6125",
    stroke: "#24284E",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7666 21.6925L77.7666 21.0771",
    stroke: "#24284E",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7666 28.4611L77.7666 27.8457",
    stroke: "#24284E",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110 118C123.255 118 134 107.255 134 94C134 80.7452 123.255 70 110 70C96.7452 70 86 80.7452 86 94C86 107.255 96.7452 118 110 118Z",
    fill: "#55CF7E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.152 92.1543L122.922 106.924",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.152,
    cy: 92.1521,
    r: 11.0769,
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.46 89.3803V89.3803C110.46 88.3607 109.634 87.5342 108.614 87.5342H107.691C106.671 87.5342 105.845 88.3607 105.845 89.3803V89.7197C105.845 90.3682 106.185 90.9691 106.741 91.3027L109.564 92.9964C110.12 93.33 110.46 93.931 110.46 94.5795V94.9188C110.46 95.9384 109.634 96.7649 108.614 96.7649H107.691C106.671 96.7649 105.845 95.9384 105.845 94.9188V94.9188",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.151 87.5364L108.151 86.6133",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.151 97.6916L108.151 96.7686",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154 122C138.536 122 126 109.464 126 94C126 78.536 138.536 66 154 66C169.464 66 182 78.536 182 94C182 109.464 169.464 122 154 122Z",
    fill: "#55CF7E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M156.154 91.8477L138.924 109.078",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9231,
    cy: 12.9231,
    r: 12.9231,
    transform: "matrix(-1 0 0 1 169.078 78.9229)",
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M158.848 88.6138V88.6138C158.848 87.4243 157.884 86.46 156.695 86.46H155.618C154.428 86.46 153.464 87.4243 153.464 88.6138V89.0097C153.464 89.7663 153.861 90.4674 154.51 90.8566L157.803 92.8325C158.452 93.2218 158.848 93.9229 158.848 94.6794V95.0753C158.848 96.2649 157.884 97.2292 156.695 97.2292H155.618C154.428 97.2292 153.464 96.2649 153.464 95.0753V95.0753",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M156.155 86.4617L156.155 85.3848",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.155 98.3084L156.155 97.2314",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M122 74C104.327 74 90 59.6731 90 42C90 24.3269 104.327 10 122 10C139.673 10 154 24.3269 154 42C154 59.6731 139.673 74 122 74Z",
    fill: "#55CF7E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M124.461 39.541L104.769 59.2333",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7692,
    cy: 14.7692,
    r: 14.7692,
    transform: "matrix(-1 0 0 1 139.231 24.7686)",
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.54 35.8414V35.8414C127.54 34.482 126.438 33.3799 125.078 33.3799H123.847C122.488 33.3799 121.386 34.482 121.386 35.8414V36.2939C121.386 37.1585 121.839 37.9598 122.581 38.4046L126.345 40.6628C127.086 41.1077 127.54 41.9089 127.54 42.7736V43.226C127.54 44.5855 126.438 45.6876 125.078 45.6876H123.847C122.488 45.6876 121.386 44.5855 121.386 43.226V43.226",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M124.462 33.3831L124.462 32.1523",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M124.462 46.9232L124.462 45.6924",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 89C63 87.8954 63.8954 87 65 87H85.2654C86.2607 87 87.1046 87.7319 87.2453 88.7172L90.7547 113.283C90.8954 114.268 91.7393 115 92.7346 115H193.265C194.261 115 195.105 114.268 195.245 113.283L198.755 88.7172C198.895 87.7319 199.739 87 200.735 87H221C222.105 87 223 87.8954 223 89V115V141C223 142.105 222.105 143 221 143H191H95H65C63.8954 143 63 142.105 63 141V115V89Z",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 52.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 113.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 122.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.5,
    cy: 38.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 35 147)",
    fill: "#24284E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 21L240 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M240 71.5L255 74.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 28.5L30 25.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 78.5L25.5 81",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveFinanceTracking);
export default __webpack_public_path__ + "static/media/collective-finance-tracking.123c2ad69d347b3ad0567ffd9f856515.svg";
export { ForwardRef as ReactComponent };